import * as types from './mutation-types'

export default {
  [types.SET_SOCIETY](state, data) {
    state.society = data.society
    state.canCreateShop = data.can_create_shop
  },
}
